var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.645 36.5386L108.168 128.259L74.5593 138.462L41.0433 128.273L33.5742 36.5386H115.645Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.645 36.5386L108.168 128.259L74.5593 138.462L41.0433 128.273L33.5742 36.5386H115.645Z",
    fill: "#E44D26",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6094 130.769L101.789 122.533L108.184 44.231H74.6094V130.769Z",
    fill: "#F16529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6094 130.769L101.789 122.533L108.184 44.231H74.6094V130.769Z",
    fill: "#F16529"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8772 66.9758H74.6095V55.769H48.4961L48.7452 58.7756L51.3049 89.6584H74.6095V78.4517H60.829L59.8772 66.9758ZM62.2243 95.2619H51.7703L53.2291 112.858L74.5615 119.231L74.6095 119.217V107.557L74.5638 107.57L62.9658 104.2L62.2243 95.2619Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8772 66.9758H74.6095V55.769H48.4961L48.7452 58.7756L51.3049 89.6584H74.6095V78.4517H60.829L59.8772 66.9758ZM62.2243 95.2619H51.7703L53.2291 112.858L74.5615 119.231L74.6095 119.217V107.557L74.5638 107.57L62.9658 104.2L62.2243 95.2619Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0352 11.5386H46.2724V17.254H51.0635V11.5386H56.3011V28.8463H51.0638V23.0507H46.2728V28.8463H41.0355V11.5386H41.0352ZM63.188 17.2782H58.578V11.5386H73.0391V17.2782H68.4262V28.8463H63.1889V17.2782H63.1886H63.188ZM75.3341 11.5386H80.795L84.1542 17.62L87.5102 11.5386H92.9734V28.8463H87.7574V20.2676L84.1542 26.4215H84.0639L80.4584 20.2676V28.8463H75.3341V11.5386ZM95.5798 11.5386H100.819V23.1255H108.184V28.8463H95.5795V11.5386H95.5798Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0352 11.5386H46.2724V17.254H51.0635V11.5386H56.3011V28.8463H51.0638V23.0507H46.2728V28.8463H41.0355V11.5386H41.0352ZM63.188 17.2782H58.578V11.5386H73.0391V17.2782H68.4262V28.8463H63.1889V17.2782H63.1886H63.188ZM75.3341 11.5386H80.795L84.1542 17.62L87.5102 11.5386H92.9734V28.8463H87.7574V20.2676L84.1542 26.4215H84.0639L80.4584 20.2676V28.8463H75.3341V11.5386ZM95.5798 11.5386H100.819V23.1255H108.184V28.8463H95.5795V11.5386H95.5798Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6097 89.6612H87.4462L86.2359 104.197L74.6094 107.571V119.231L95.9801 112.863L96.1367 110.969L98.5867 81.4631L98.841 78.4535H74.6097V89.6612ZM74.6097 66.9493V66.9767H99.7895L99.9984 64.4577L100.474 58.7758L100.723 55.769H74.6097V66.9497V66.9493Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6097 89.6612H87.4462L86.2359 104.197L74.6094 107.571V119.231L95.9801 112.863L96.1367 110.969L98.5867 81.4631L98.841 78.4535H74.6097V89.6612ZM74.6097 66.9493V66.9767H99.7895L99.9984 64.4577L100.474 58.7758L100.723 55.769H74.6097V66.9497V66.9493Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/Html5.f79ab0289e83074d6e835a5bf0fcdb91.svg";
export { ForwardRef as ReactComponent };